@if (isDataLoaded) {
  @if (HasOutstandingAddressMatches && doAddressMatch && !addressMatchDoneAlready) {
    <div class="alert alert-warning" role="alert">
      Please check and update the fields highlighted below.
    </div>
  }
  @if (CurrentStep>103) {
    <recap-loan-details
      [loanDetails]="LoanDetails"
      (stageChange)="changeStage($event)"
    [showEditButton]="showEditButtons"></recap-loan-details>
  }
  @if (CurrentStep>104) {
    <recap-applicant-details
      [applicantDetails]="ApplicantDetails"
      (stageChange)="changeStage($event)"
      [showEditButton]="showEditButtons"
      [addressMatchDoneAlready]="addressMatchDoneAlready"
      [doAddressMatch]="doAddressMatch"
    (outputApplicant)="receiveApplicant($event)"></recap-applicant-details>
  }
  @if (CurrentStep>105) {
    <recap-income-details
      [incomeDetails]="IncomeDetails"
      (stageChange)="changeStage($event)"
    [showEditButton]="showEditButtons"></recap-income-details>
  }
  @if (CurrentStep>106) {
    <recap-property-details
      [propertyDetails]="PropertyDetails"
      (stageChange)="changeStage($event)"
    [showEditButton]="showEditButtons"></recap-property-details>
  }
  @if (CurrentStep>108) {
    <recap-additional-security
      [additionalDetails]="AdditionalDetails"
      (stageChange)="changeStage($event)"
    [showEditButton]="showEditButtons"></recap-additional-security>
  }
  @if (CurrentStep >= 109) {
    <recap-solicitor-details
      [solicitorDetails]="SolicitorDetails"
      (stageChange)="changeStage($event)"
    [showEditButton]="showEditButtons"></recap-solicitor-details>
  }
}
